import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse, IndicacaoFiltros, IndicacaoGanhoMensal } from './indicacao.types';

export const getIndicacaoEvolucaoRepasse = async (filtros?: IndicacaoFiltros) => {
	try {
		const response = await BaseClient.get<IndicacaoApiResponse<IndicacaoGanhoMensal[]>>(
			'v2/Indicacao/EvolucaoRepasse',
			{
				params: {
					data_inicio: filtros?.data_inicio || undefined,
					data_fim: filtros?.data_fim || undefined,
					id_usuario: filtros?.id_usuario || undefined,
				},
			}
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<IndicacaoGanhoMensal[]>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
